import headline from './headline';
import mailing from './mailing';

export default {
  headline,
  mailing,
};
